<template>
	<div v-show="myFx">
		<div class="user-panel">
			<header>Dane podstawowe</header>
			<dl>
				<div
					v-if="
						myFx.proxyAccountFirstName || myFx.proxyAccountLastName
					"
					style="border-bottom: 1px solid #ececec"
				>
					<dt>Pełnomocnik</dt>
					<dd></dd>
				</div>
				<dt>Imię Nazwisko</dt>
				<dd>{{ myFx.firstName }} {{ myFx.lastName }}</dd>

				<dt>Data Urodzenia</dt>
				<dd>
					{{ $filters.date(myFx.dateOfBirth) }}
				</dd>

				<dt>PESEL</dt>
				<dd>{{ myFx.pesel }}</dd>

				<dt>Dokument tożsamości</dt>
				<dd>
					{{
						myFx.documentTypeId === 2
							? 'Dowód osobisty'
							: myFx.documentTypeId === 3
							? 'mObywatel'
							: 'Paszport'
					}}: {{ myFx.documentNumber }}
				</dd>

				<dt>Data ważności dokumentu</dt>
				<dd v-if="myFx.documentValidityDate !== null">
					{{ $filters.date(myFx.documentValidityDate) }}
				</dd>
				<dd v-else>
					{{
						myFx.documentTypeId === 2
							? 'Ważny bezterminowo'
							: 'Brak'
					}}
				</dd>

				<dt>Obywatelstwo</dt>
				<dd>
					<template v-if="myFx.citizenshipId">{{
						getDictionaryItem(
							dictCountries,
							'text',
							'value',
							myFx.citizenshipId
						)
					}}</template>
				</dd>

				<dt>Nazwisko panieńskie matki</dt>
				<dd>
					<template v-if="myFx.motherMaidenName">{{
						myFx.motherMaidenName
					}}</template>
				</dd>
			</dl>
		</div>
		<div class="user-panel">
			<header>Dane kontaktowe</header>
			<dl>
				<dt>Adres zamieszkania</dt>
				<dd>
					<address-preview :address="myFx.mainAddress" />
				</dd>

				<dt>Adres do korespondencji</dt>
				<dd>
					<template v-if="myFx.correspondenceAddressLikeMainAddress"
						>Ten sam co zamieszkania</template
					>
					<template v-else>
						<address-preview :address="myFx.correspondAddress" />
					</template>
				</dd>

				<dt>Telefon</dt>
				<dd>{{ myFx.mobilePhone }}</dd>

				<dt>Hasło telefoniczne</dt>
				<dd>{{ myFx.phonePassword }}</dd>

				<dt>E-mail</dt>
				<dd>{{ myFx.email }}</dd>
			</dl>
		</div>
		<div class="user-panel">
			<header>Rachunki bankowe do wpłat NRB</header>
			<dl>
				<template v-for="(account, i) in bankAccountList">
					<dt v-if="account.clientAccount" :key="'a' + i">
						{{ account.clientDescription }}
					</dt>
					<dd v-if="account.clientAccount" :key="'b' + i">
						{{ account.nrb }}
					</dd>
				</template>
			</dl>
		</div>
		<div class="user-panel">
			<header>Dane bankowe do wypłat</header>
			<dl>
				<template v-for="(account, i) in bankAccountList">
					<dt v-if="!account.clientAccount" :key="'a' + i">
						{{ account.clientDescription }}
					</dt>
					<dd v-if="!account.clientAccount" :key="'b' + i">
						{{ account.nrb }}
					</dd>
				</template>
			</dl>
		</div>
		<div class="user-panel">
			<header class="mb-3">Oświadczenie o rezydencji podatkowej</header>
			<p>
				Jestem świadomy odpowiedzialności karnej za złożenie fałszywego
				oświadczenia.
			</p>
			<p>
				{{
					myFx.isResident
						? 'Rozliczam się z podatków w Polsce (jestem polskim rezydentem podatkowym).'
						: 'Nie rozliczam się z podatków w Polsce (nie jestem polskim rezydentem podatkowym), ponieważ wskazałem adres zamieszkania poza Polską.'
				}}
			</p>
			<dl>
				<dt>Urząd skarbowy</dt>
				<dd style="max-width: 470px">
					{{
						getDictionaryItem(
							taxTaxAddressesList,
							'text',
							'value',
							myFx.taxOfficeId
						)
					}}
				</dd>

				<dt>FATCA</dt>
				<dd style="max-width: 470px">
					{{
						myFx.isUsaTaxPayeeOrHasUsaCitizenship
							? 'Jestem obywatelem USA/jestem amerykańskim rezydentem podatkowym zgodnie z amerykańskim kodeksem podatkowym.'
							: 'Nie jestem obywatelem USA/nie jestem amerykańskim rezydentem podatkowym zgodnie z amerykańskim kodeksem podatkowym.'
					}}
				</dd>

				<dt>TIN</dt>
				<dd style="max-width: 470px">{{ myFx.usaTin }}</dd>

				<dt>Oświadczenie CRS</dt>
				<dd style="max-width: 470px">
					{{
						myFx.isOtherCountryTaxPayee
							? 'Oświadczam, że jestem podatnikiem (rezydentem podatkowym) w innych państwach.'
							: 'Oświadczam, że nie jestem podatnikiem (rezydentem podatkowym) w innych państwach.'
					}}
				</dd>

				<dt>Inne kraje podatkowe</dt>
				<dd style="max-width: 470px">
					{{ myFx.isOtherCountryTaxPayee ? '' : 'Brak' }}
					<p
						v-for="country in myFx.countryOfTaxPayee"
						:key="country.id"
					>
						<b>{{ country.countryName }}</b>
						,
						{{
							!country.lackTin
								? 'TIN:' + country.tinNumber
								: 'brak TIN - państwo rezydencji podatkowej nie nadało TIN Posiadaczowi Rachunku'
						}}
					</p>
				</dd>
			</dl>
		</div>
		<div class="user-panel">
			<header>Zgody</header>
			<ul class="agreements-list">
				<li
					v-for="agreement in myFx.agreements"
					:key="agreement.agreementId"
				>
					<img
						class="float-left"
						:alt="
							agreement.isAccepted
								? 'Zgoda wyrażona'
								: 'Zgoda niewyrażona'
						"
						:src="
							agreement.isAccepted
								? 'images/check.svg'
								: 'images/close.svg'
						"
					/>
					<p style="overflow: hidden">
						{{ agreement.title }}
						<button
							class="px-0 px-lg-1"
							@click="
								agreement.isContentVisible =
									!agreement.isContentVisible
							"
							type="button"
						>
							Pełna treść klauzuli
						</button>
					</p>
					<transition name="slide-up">
						<div
							v-if="agreement.isContentVisible"
							class="agreement-full"
						>
							{{ agreement.content }}
						</div>
					</transition>
				</li>
			</ul>
		</div>
		<router-link to="/MyFxEdit" class="btn btn-primary"
			>Zmień dane</router-link
		>
		<button
			v-if="user.showValidateDataDialog"
			@click="confirmOwkData"
			class="btn btn-primary"
		>
			Potwierdzam aktualność danych
		</button>
		<p class="mt-2">
			Zapisując zmiany potwierdzam, że wszystkie powyższe dane są aktualne
		</p>
		<br />
		<br />
	</div>
</template>

<script>
import AddressPreview from '@/components/AddressPreview';
import { getDictionaryItem } from '@/mixins/get-dictionary-item';

export default {
	components: {
		AddressPreview,
	},
	mixins: [getDictionaryItem],
	computed: {
		myFx() {
			return this.$store.getters.getMyFx
				? this.$store.getters.getMyFx
				: false;
		},
		user() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
		dictCountries() {
			return this.$store.getters.getCountries
				? this.$store.getters.getCountries
				: false;
		},
		bankAccountList() {
			return this.$store.getters.getBankAccountList
				? this.$store.getters.getBankAccountList
				: false;
		},
		taxTaxAddressesList() {
			return this.$store.getters.getTaxAddresses
				? this.$store.getters.getTaxAddresses
				: false;
		},
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
	},
	methods: {
		confirmOwkData() {
			this.$store
				.dispatch('confirmOwkData', this.myFx)
				.then((res) => {
					this.$store.commit('setGlobalSuccessMessage', res);
				})
				.catch((err) => {
					this.$store.commit('setGlobalErrorMessage', err);
					this.$store.commit('setGlobalSuccessMessage', '');
				});
		},
	},
};
</script>
